import { Link } from "react-router-dom";
import { categories } from "@/mocks/archive";

export default function Footer() {
  return (
    <footer className="bg-background-100">
      <div className="h-1 bg-gradient-to-r from-primary-500 via-accent-500 to-secondary-500" />
      <div className="container-x py-12">
        <div className="grid gap-10 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-line text-lg" />
              </span>
              <span className="font-heading text-xl font-bold text-foreground-950">新瓜档案</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-500">
              一本专注记录「新晋人物」的吃瓜档案。我们追踪新爆料主角、新人黑料与新兴人物的第一手动态，帮你把这些刚冒头的新面孔一次认清。
            </p>
            <p className="mt-4 text-xs text-foreground-400">
              邮箱：<a href="mailto:hello@xingua-dangan.cn" className="text-primary-600 hover:underline">hello@xingua-dangan.cn</a>
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-900">热门栏目</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((c) => (
                <li key={c.slug}>
                  <Link to={`/archives?cat=${c.slug}`} className="text-foreground-500 transition-colors hover:text-primary-600">
                    {c.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-heading text-sm font-bold text-foreground-900">快捷入口</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link to="/" className="text-foreground-500 hover:text-primary-600">首页</Link></li>
              <li><Link to="/archives" className="text-foreground-500 hover:text-primary-600">人物档案</Link></li>
              <li><Link to="/about" className="text-foreground-500 hover:text-primary-600">关于本站</Link></li>
              <li><Link to="/archives" className="text-foreground-500 hover:text-primary-600">搜索新面孔</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-heading text-sm font-bold text-foreground-900">阅读提示</h4>
            <p className="mt-4 text-sm leading-relaxed text-foreground-500">
              本站内容仅供娱乐参考，所涉人物均为虚构示例。请理性吃瓜，切勿以档案内容对任何人定性。
            </p>
            <div className="mt-4 flex gap-2">
              <span className="tag">理性吃瓜</span>
              <span className="tag">不传谣</span>
              <span className="tag">每日更新</span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-400">© 2026 新瓜档案 · 新晋人物吃瓜档案站 · 保留所有权利</p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <Link to="/about" className="hover:text-primary-600">内容准则</Link>
            <Link to="/about" className="hover:text-primary-600">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}